<script>
    export let type;
    export let content;
    export let props;
</script>

{#if type == 'basic'}
    <default></default>
{/if}

{#if type == 'calendar'}
    <div class="card-calendar {props.spaced ? 'card-calendar_spaced' : null}" style="background: url({content.thumbnail}) center/cover no-repeat">
        <div class="topbar">
            <h3>{content.date}</h3>
            <small>{content.hours}</small>
        </div>
        <div class="content">
            <h4 class="title">{content.title}</h4>
            <span class="description">{content.description}</span>
        </div>
    </div>
{/if}

{#if type == 'quote'}
    <div class="card-quote {props.spaced ? 'card-quote_spaced' : null}">
        <span class="description">{content.description}</span>
        <a href="" class="read-more" data-post-id={content.id}>Czytaj więcej <i class="fas fa-arrow-right"></i></a>
    </div>
{/if}

{#if type =='news'}
    <a class="card-news post-module {props.spaced ? 'card-quote_spaced' : null}" href={content.url} target="_blank">
        <div class="thumbnail">
            <div class="date">
                <div class="day">{new Date(content.date).getDay()}</div>
                <div class="month">{new Date(content.date).toLocaleDateString('pl', {month: 'short'})}</div>
            </div>
            <div class="image" style="background: url({content.thumbnail}) center/cover no-repeat"></div>
        </div>
        <div class="post-content">
            <div class="category">{content.description}</div>
            <h1 class="title">{content.title}</h1>
        </div>
    </a>
{/if}

{#if type == 'youtube'}
    <div class="card-youtube {props.spaced ? 'card-quote_spaced' : null}">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/{content.movieID}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
{/if}

<style type="text/scss">
    @import './calendar.scss';
    @import './news.scss';
    @import './quote.scss';
    @import './youtube.scss';
</style>